var _path, _circle, _circle2, _circle3, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFoundIllustrationOne(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 124,
    height: 202,
    viewBox: "0 0 124 202",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M112.471 138.11C90.369 141.271 46.2634 137.525 46.6532 97.2523C47.1405 46.9108 112.572 115.306 60.1095 118.493C18.1392 121.043 6.26918 83.054 5.58043 63.7408",
    stroke: "#4DFFFF",
    strokeWidth: 10,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48.5,
    cy: 5.5,
    r: 5.5,
    fill: "#4DFFFF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.5,
    cy: 143.5,
    r: 4.5,
    fill: "#4DFFFF"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 75.5,
    cy: 191.5,
    r: 10.5,
    fill: "#4DFFFF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113.244 6C104.531 9.70408 95.8006 19.2066 98.4983 31.2551C101.514 44.7245 128.324 48.0918 115.59 72",
    stroke: "#4DFFFF",
    strokeWidth: 10,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFoundIllustrationOne);
export default __webpack_public_path__ + "static/media/found_illustration_one.d98f6c80c1b28dc0c1dc2be7299f3b7f.svg";
export { ForwardRef as ReactComponent };